import "../components/styles/Footer.css"
function Footer (){
    return( 
    
    <footer>
        <div className="wrapper">
            <p>Made by <a href="https://Tristanthorburn.com" target="_blank" rel="noreferrer">Tristan Thorburn</a>, 
            <a href="https://Shaishav.ca" target="_blank" rel="noreferrer"> Shaishav Vashi</a>, 
            and 
            <a href="https://dildeepgill.com" target="_blank" rel="noreferrer"> Dildeep Gill</a>
            </p>
        </div>    
    </footer> 
    )
}

export default Footer